module.exports = require('./helpers/bundle-url').getBundleURL('sif1r') + "Icon Blue 192.195958a8.png";